<div  v-bind:class="getClassName" class="matrix_selectOption">
    <div class="matrix_selectOptionName">{{name}}</div>
    <Select2
        :options="getQuantities"
        v-model="value"
        :id="getId"
        :settings="settings"
    />
</div>

